// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OTilie Answer Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CurrentUserResponse
 */
export interface CurrentUserResponse {
    /**
     * 
     * @type {string}
     * @memberof CurrentUserResponse
     */
    oid: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserResponse
     */
    role: string;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentUserResponse
     */
    isAdmin: boolean;
}

/**
 * Check if a given object implements the CurrentUserResponse interface.
 */
export function instanceOfCurrentUserResponse(value: object): value is CurrentUserResponse {
    if (!('oid' in value) || value['oid'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('isAdmin' in value) || value['isAdmin'] === undefined) return false;
    return true;
}

export function CurrentUserResponseFromJSON(json: any): CurrentUserResponse {
    return CurrentUserResponseFromJSONTyped(json, false);
}

export function CurrentUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrentUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'oid': json['oid'],
        'role': json['role'],
        'isAdmin': json['is_admin'],
    };
}

export function CurrentUserResponseToJSON(json: any): CurrentUserResponse {
    return CurrentUserResponseToJSONTyped(json, false);
}

export function CurrentUserResponseToJSONTyped(value?: CurrentUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'oid': value['oid'],
        'role': value['role'],
        'is_admin': value['isAdmin'],
    };
}

